export default {"src":"/_next/static/media/CollectionIconCategory.f53da4e0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};